import styled from 'styled-components';
// components
import HeaderTitleMessage from 'components/atoms/messages/header/Title';
import BaseHeader, { HeaderBlank } from 'components/layout/headers/Base';
// styles
import { palette, mediaQuery, mediaValue } from 'cds/styles';

/**
 * 좌/우 컨텐츠 존재 헤더
 * @param {object} props
 * @param {string} props.message
 * @param {import('react').ReactNode} props.leftSide
 * @param {import('react').ReactNode} props.rightSide
 * @param {import('react').ReactNode} props.centerSide
 * @param {boolean} props.noBorderBottom
 */
const BothHeader = ({ message, leftSide, centerSide, rightSide, noBorderBottom, ...props }) => {
  return (
    <>
      <Header noBorderBottom={noBorderBottom} {...props}>
        <ContentLayout>
          <Item>{leftSide}</Item>
          {centerSide && centerSide}
          {!centerSide && <HeaderTitleMessage message={message} />}
          <Item>{rightSide}</Item>
        </ContentLayout>
      </Header>
      <HeaderBlank />
    </>
  );
};

const Header = styled(BaseHeader)`
  border-bottom: ${({ noBorderBottom }) =>
    noBorderBottom ? '' : `1px solid ${palette.system.BNB}`};

  ${mediaQuery.large} {
    height: 84px;
    border-bottom: ${({ noBorderBottom }) =>
      noBorderBottom ? '' : `1px solid ${palette.system.grey}`};
  }
`;

const ContentLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  flex-wrap: nowrap;
  max-width: 100%;
  width: ${mediaValue.medium}px;
  height: 100%;
  padding: 0 16px;
  margin: auto;
`;

const Item = styled.div`
  flex-basis: 50%;
  width: 50px;

  &:first-child {
    display: flex;
    justify-content: flex-start;
  }

  &:last-child {
    display: flex;
    justify-content: flex-end;
  }

  svg {
    fill: ${palette.grey50};
  }
`;

export default BothHeader;
